export default {
    // baseUrl: "https://www.qishunjiaogui.com.cn",
    baseUrl: "https://admin.qishunjiaogui.com.cn", // 正式
    // baseUrl: "http://qishun.udous.cn", // 测试
}


// 外网面板地址: http://124.70.208.151:8888/ee00ff75
// 内网面板地址: http://192.168.0.6:8888/ee00ff75
// username: 9mmywp9l
// password: 665ef275



// WEBPACK FOOTER //
// ./src/aixos/urls.js